import { DataTableProvider } from 'components/DataTable'
import { IColumnVisibility } from 'components/DataTable/types'

import { ChainsSummary } from 'models/summaries'
import { FilterIdentifier } from 'models/saved_view'

import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { ChainsTableComponent } from './ChainsTableComponent'
import { featureFlagService } from 'utils/featureFlagService'
import { ChainsTableComponentV2 } from './ChainsTableComponentV2'

export interface IChainTable {
  setChainsSummary?: (summary: ChainsSummary) => void
  baseFilters?: Record<string, any>
  tableKey: string
  filterIdentifierModifier?: FilterIdentifier
  hideCreateCompanyButton?: boolean
}

export function ChainsTable(
  props: IChainTable & {
    defaultColumnVisibility?: IColumnVisibility<any>
  }
) {
  const { tableKey, defaultColumnVisibility, ...rest } = props
  const { enabledReportChains, isLoading } = featureFlagService()

  if (isLoading) {
    return null
  }

  if (enabledReportChains) {
    return (
      <ColumnsStoreProvider
        tableKey={tableKey}
        defaultColumnVisibility={defaultColumnVisibility}
        savedPresetsIdentifier={'CHAINS_TABLE'}
        preferredGroupOrder={[
          'Target Attributes',
          'Campaigns and Deals',
          'Predicted Values',
          'Reputation Data',
          'Location Data',
        ]}
      >
        <DataTableProvider tableKey={tableKey}>
          <ChainsTableComponentV2 tableKey={tableKey} {...rest} />
        </DataTableProvider>
      </ColumnsStoreProvider>
    )
  }

  return (
    <ColumnsStoreProvider
      tableKey={tableKey}
      defaultColumnVisibility={defaultColumnVisibility}
      savedPresetsIdentifier={'CHAINS_TABLE'}
      preferredGroupOrder={[
        'Target Attributes',
        'Campaigns and Deals',
        'Predicted Values',
        'Reputation Data',
        'Location Data',
      ]}
    >
      <DataTableProvider tableKey={tableKey}>
        <ChainsTableComponent tableKey={tableKey} {...rest} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
